<template>
    <BCard class="mb-3 border-info shadow-sm">
        <template #header>
            <h5 class="mb-0 text-info font-weight-bold text-left">2. Itinerary</h5>
        </template>
         <BTableSimple hover small responsive bordered striped>
            <BThead head-variant="light">
                <BTr>
                    <BTh>Date</BTh>
                    <BTh>Route</BTh>
                    <BTh>Distance (km)</BTh>
                    <BTh>Hotel</BTh>
                    <BTh class="text-end">Amount (Salary)</BTh>
                    <BTh class="text-center" style="width: 100px">Action</BTh>
                </BTr>
            </BThead>
            <BTbody>
                <BTr v-for="(item, index) in form.programs" :key="index">
                    <BTd>{{ item.date }}</BTd>
                    <BTd>
                        {{ item.route_name }} 
                        <span v-if="item.route_description">({{ item.route_description }})</span>
                    </BTd>
                    <BTd>{{ item.distance || '' }}</BTd>
                    <BTd>{{ item.hotel_name }}</BTd>
                    <BTd class="text-end">{{ formatCurrency(item.amount) }}</BTd>
                    <BTd class="text-center">
                        <BButton variant="warning" size="sm" class="me-1" @click="editItem(index)"><i class="fas fa-edit"></i></BButton>
                        <BButton variant="danger" size="sm" @click="removeProgram(index)"><i class="fas fa-trash"></i></BButton>
                    </BTd>
                </BTr>
                <BTr v-if="form.programs.length === 0">
                    <BTd colspan="6" class="text-center text-muted">No itinerary items. Select an Invoice Tour to auto-generate</BTd>
                </BTr>
            </BTbody>
         </BTableSimple>
         <BButton variant="primary" size="sm" @click="openModal" class="mb-3"><i class="fas fa-plus"></i> Add Itinerary Item</BButton>

         <ItineraryForm v-if="modalVisible"
            :modal="modalVisible"
            @update:modal="modalVisible = $event"
            :selected-data="selectedData"
            :route-options="routeList"
            @add-or-update="addOrUpdate"
         />
    </BCard>
</template>

<script setup>
import { inject, ref, onMounted } from "vue";
import { BTableSimple, BThead, BTbody, BTr, BTh, BTd, BButton, BCard } from "bootstrap-vue-next";
import axios from "axios";
import { useAuthStore } from "@/store/auth";
import ItineraryForm from "../ItineraryForm.vue";

const form = inject('form');
const auth = useAuthStore();
const modalVisible = ref(false);
const selectedData = ref(null);

const routeList = ref([]);

const loadRoutes = async () => {
    try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/route`, {
             headers: { Authorization: `Bearer ${auth._token}` }
        });
        if(res.data.status) {
             routeList.value = res.data.data.map(r => {
                const from = r.from?.name || r.from_destination?.name || 'Unknown';
                const to = r.to?.name || r.to_destination?.name || 'Unknown';
                const desc = r.description ? ` (${r.description})` : '';
                const label = `${from} - ${to}${desc}`;
                return {
                    uuid: r.uuid,
                    label: label,
                    from: from,
                    to: to,
                    distance: r.distance,
                    description: r.description
                };
             });
        }
    } catch(e) { console.error(e); }
};

const openModal = () => {
    const defaultDate = form.start || '';
    selectedData.value = { date: defaultDate, amount: 0 };
    modalVisible.value = true;
};

const editItem = (index) => {
    selectedData.value = { ...form.programs[index], index };
    modalVisible.value = true;
};

const addOrUpdate = (payload) => {
    if (payload.index !== undefined) {
        form.programs[payload.index] = payload;
    } else {
        form.programs.push(payload);
    }
    modalVisible.value = false;
};

const removeProgram = (index) => {
    form.programs.splice(index, 1);
};

const formatCurrency = (val) => {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val);
};

onMounted(() => {
    loadRoutes();
});
</script>
